import { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown, Home, Sparkles, ScanFace, LogOut, ArrowRight, Rocket } from 'lucide-react';

export const BackMenu = ({ tenantSlug, onLogout, testId = 'back-menu' }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, []);

  const items = [
    { to: '/', icon: Home, label: 'Spotfie home', hint: 'Landing page', tid: 'back-menu-home' },
    { to: '/demo', icon: Sparkles, label: 'Live demo hub', hint: 'Guest + organiser tour', tid: 'back-menu-demo' },
    ...(tenantSlug ? [{ to: `/t/${tenantSlug}`, icon: ScanFace, label: 'My guest portal', hint: `/t/${tenantSlug}`, tid: 'back-menu-portal' }] : []),
  ];

  return (
    <div className="relative" ref={ref} data-testid={testId}>
      <button onClick={() => setOpen((o) => !o)} className="btn-ghost !py-2 !px-3" data-testid={`${testId}-btn`} aria-expanded={open}>
        <Home className="w-4 h-4" /> <span className="hidden sm:inline">Back to Spotfie</span> <ChevronDown className={`w-3.5 h-3.5 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-64 bg-surface border-2 border-cyan shadow-[0_18px_40px_rgba(40,35,52,0.10)] z-50 fade-up" data-testid={`${testId}-panel`}>
          {items.map(({ to, icon: Icon, label, hint, tid }) => (
            <Link key={to} to={to} data-testid={tid} onClick={() => setOpen(false)} className="flex items-center gap-3 px-4 py-3 border-b border-line hover:bg-panel transition-colors">
              <Icon className="w-4 h-4 text-cyan shrink-0" />
              <span className="min-w-0"><span className="block font-display font-bold uppercase tracking-wider text-xs text-white">{label}</span><span className="block font-mono text-[10px] text-slate-500 truncate">{hint}</span></span>
            </Link>
          ))}
          <button onClick={() => { setOpen(false); onLogout(); }} data-testid="back-menu-logout" className="w-full flex items-center gap-3 px-4 py-3 hover:bg-panel transition-colors text-left">
            <LogOut className="w-4 h-4 text-slate-400 shrink-0" />
            <span className="font-display font-bold uppercase tracking-wider text-xs text-slate-300">Log out</span>
          </button>
        </div>
      )}
    </div>
  );
};

export const DemoBanner = () => (
  <div className="bg-lime text-ink border-b-2 border-lime" data-testid="demo-banner">
    <div className="px-6 lg:px-10 py-3 flex flex-col sm:flex-row sm:items-center justify-between gap-3">
      <p className="text-sm font-semibold flex items-center gap-2">
        <Rocket className="w-4 h-4 shrink-0" />
        You're exploring the <span className="font-display uppercase tracking-wider">demo workspace</span>. Upload and explore freely — the sample guest and photos are protected. Your first event is free.
      </p>
      <div className="flex items-center gap-2 shrink-0">
        <Link to="/signup" data-testid="demo-banner-signup" className="inline-flex items-center gap-2 font-display font-bold uppercase tracking-wider text-xs px-4 py-2 bg-ink text-white border-2 border-ink shadow-sm hover:-translate-y-0.5 transition-all">
          Create my free event <ArrowRight className="w-3.5 h-3.5" />
        </Link>
        <Link to="/#pricing" data-testid="demo-banner-pricing" className="font-mono text-[11px] uppercase tracking-[0.2em] text-ink/70 hover:text-ink px-2">Pricing</Link>
      </div>
    </div>
  </div>
);
